const Footer = () => {
  return (
    <footer>
      <p>&copy; 2023 P1</p>
    </footer>
  );
};

export default Footer;
